var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "table offer-info" },
    [
      _vm._l(_vm.rounds, function (round) {
        return round.ssrRoundSupplierCapacities.length > 0 ||
          round.supplierCapacityFiles.length > 0
          ? _c(
              "div",
              [
                _c(
                  "div",
                  [
                    _vm._v("Round " + _vm._s(round.roundNumber) + " "),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.offerDownload(round.ttSsrRoundId)
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.$t("ssrManage.offerDownload")))]
                    ),
                  ],
                  1
                ),
                _c("capacity-table", {
                  attrs: {
                    "round-id": round.ttSsrRoundId,
                    files: round.supplierCapacityFiles,
                    suppliers: round.ssrRoundSuppliers,
                    type: "capacityAnalysis",
                    template: round.capacityTemplate,
                    "can-edit": _vm.canEdit,
                    data: round.ssrRoundSupplierCapacities,
                  },
                }),
              ],
              1
            )
          : _vm._e()
      }),
      _c(
        "el-row",
        {
          staticStyle: { "padding-top": "15px" },
          attrs: { type: "flex", justify: "center" },
        },
        [
          _vm.roundIds.length > 1
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.offerDownload(_vm.roundIds)
                    },
                  },
                },
                [_vm._v("Download All")]
              )
            : _vm._e(),
          _vm.roundIds.length > 1
            ? _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.downloadFile()
                    },
                  },
                },
                [_vm._v("Download All File")]
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }